import {
  Box,
  Button,
  Drawer,
  makeStyles,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../services/client/rest";
import { ConvetToLocalTime } from "../../services/utils";

const useStyles = makeStyles((theme) => ({
  inActiveDealer: {
    color: "red",
    textDecoration: "line-through",
  },
}));

function CrmUsers({
  open,
  dealerId,
  dmsDealerId,
  onClose,
  tag,
  dmsType,
}: {
  open: boolean;
  dealerId: number;
  dmsDealerId: number;
  onClose: any;
  tag: string;
  dmsType?: number;
}) {
  const [selectedRow, setSelectedRow] = React.useState([] as any);
  const [userData, SetUserData] = useState([]);
  const [refreshTokenData, SetRefreshTokenData] = useState([]);
  const [search, SetSearch] = React.useState<string>("");
  const [showToken, setShowToken] = React.useState(false);
  const [showRefreshTokenLog, setShowRefreshTokenLog] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAddUserDrawer, setOpenAddUserDrawer] = useState(false);
  const [addUserForm, setAddUserForm] = useState({ name: "", userName: "", password: "", email: "", isAdmin: false });
  const [addUserErrors, setAddUserErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [anchorElTokenLog, setAnchorElTokenLog] = React.useState(null);
  const [tempToken, setTempToken] = useState([] as any);
  const [hasTargetAccess, setHasTargetAccess] = useState(CheckTargetAccess);
  const classes = useStyles();
  useEffect(() => {
    if (open) {
      GetUsers();
    }
  }, [open]);

  function onUserRowClick(row: any) {
    setSelectedRow(row);
  }

  async function GetUsers() {
    var body = {
      query: "GetUsers",
      queryBody: {
        DealerId: dealerId,
      },
    };
    var token = "Y1N5c3RlbXM6U0hyaXNqMENuaGxw";
    const res = await axios.post(
      "https://csidealerProd.azurewebsites.net/api/Query",
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.length == 0) res.data = [];
    SetUserData(res.data);
  }
  function CheckTargetAccess() {
    let user: any = localStorage.getItem("user");
    let obj = JSON.parse(user);
    let obj1 = JSON.parse(obj.domainUser);
    let data_filter: any = obj1.userRoles.filter((x: any) =>
      x.includes("CSAR-Target-")
    );
    return data_filter.length >= 1;
  }

  function GetUserData(): any {
    let items = userData;
    return items;
  }

  function GetDomainUser() {
    let name = localStorage.getItem("username");
    if (name == null) {
      name = "";
    }
    return name;
  }

  async function OnTokenClick(e: any, userName: any) {
    setAnchorElTokenLog(e.currentTarget);
    let url = "https://csidealerProd.azurewebsites.net/api/Query";
    let res = await axios.post(
      url,
      {
        query: "GetUserGeneratedTokens",
        queryBody: { DealerId: dealerId, UserName: userName },
      },
      {
        auth: {
          username: "TargetWeb",
          password: "pDndckJ3wqHT",
        },
      }
    );
    SetRefreshTokenData(res.data);
    setShowRefreshTokenLog(true);
  }

  async function GenerateToken(e: any, row: any) {
    setAnchorEl(e.currentTarget);

    let obj: any = {
      dmsDealerId: dmsDealerId,
      dealerId: dealerId,
      userName: row.userName,
      GlobalId: row.GlobalId,
      DomainUser: GetDomainUser(),
    };

    let jsonString = JSON.stringify(obj);

    try {
      // Step 1: Call token API to get access token
      const tokenResponse = await axios.post(
        "https://opeidentitymanagement.azurewebsites.net/api/v1/Account/token",
        {
          clientId: "CsiCloud",
          clientSecret: "dvgi28*80y#E>/V/zaMdbgm~f|8nSPf'",
          loginResolutionPolicy: "ClientCredentials",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const accessToken = tokenResponse.data.access_token;

      // Step 2: Call IDMSTempToken API with access token in headers
      const res = await axios.post(
        "https://opeidentitymanagement.azurewebsites.net/api/v1/Account/tempToken",
        jsonString,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setTempToken(res.data);
      setShowToken(true);
    } catch (err) {
      alert("Failed to generate token. Check console for more details.");
    }
  }

  function handleAddUserChange(field: string, value: string) {
    setAddUserForm((prev) => ({ ...prev, [field]: value }));
    setAddUserErrors((prev) => ({ ...prev, [field]: "" }));
  }

  function validateAddUserForm() {
    const errors: { [key: string]: string } = {};
    if (!addUserForm.name.trim()) errors.name = "Name is required";
    if (!addUserForm.userName.trim()) errors.userName = "Username is required";
    if (!addUserForm.password.trim()) errors.password = "Password is required";
    else if (addUserForm.password.length < 6) errors.password = "Password must be at least 6 characters";
    if (!addUserForm.email.trim()) errors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addUserForm.email)) errors.email = "Invalid email format";
    return errors;
  }

  async function handleAddUserSubmit() {
    const errors = validateAddUserForm();
    if (Object.keys(errors).length > 0) {
      setAddUserErrors(errors);
      return;
    }
    setIsSubmitting(true);
    try {
      var token = "Y1N5c3RlbXM6U0hyaXNqMENuaGxw";
      await axios.post(
        "https://csidealerProd.azurewebsites.net/api/User/upsertUser",
        {
          DealerId: dealerId,
          Name: addUserForm.name,
          Username: addUserForm.userName,
          IsAdmin: addUserForm.isAdmin,
          IsService: true,
          Password: addUserForm.password,
          IsTech: true,
          IsActive: true,
          Email: addUserForm.email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("User added successfully");
      setAddUserForm({ name: "", userName: "", password: "", email: "", isAdmin: false });
      setOpenAddUserDrawer(false);
      GetUsers();
    } catch (err: any) {
      alert("Failed to add user: " + (err?.response?.data?.message || err.message || err));
    } finally {
      setIsSubmitting(false);
    }
  }

  async function OpenTarget(row: any) {
    const obj = {
      DomainUser: GetDomainUser(),
      userName: row.userName,
      GlobalId: row.GlobalId,
      productId: "1A78FF3B-60FE-4E4B-5D53-08D976A4EDC9",
      clientId: "TargetCRM",
      clientSecret: "2'XC1&f#Dd8Rt%.)F{ss6?_$`S&cEj",
    };

    const token = localStorage.getItem("token");
    if (!token) {
      alert("User is not authenticated.");
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.post(
        `${BASE_URL}Dashboard/OpenTarget`,
        obj,
        { headers }
      );

      if (!response || !response.data || !response.data.access_token) {
        alert("Invalid response from server.");
        return;
      }

      const targetUrl = `https://app.constellationdealer.com?token=${response.data.access_token}`;
      window.open(targetUrl, "_blank");
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "An error occurred while opening the target.";
        alert(`Server Error: ${errorMessage}`);
      } else {
        alert("Unexpected error: " + error.toString());
      }
    }
  }
  return (
    <Drawer
      PaperProps={{ style: { width: "auto", minWidth: "10%" } }}
      anchor="right"
      open={open}
      onClose={() => onClose()}
      variant={"temporary"}
    >
      <Box style={{ zIndex: 1000 }}>
        <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "3px" }}>
          <input
            placeholder="search"
            style={{ padding: "3px 5px" }}
            onChange={(e) => SetSearch(e.target.value)}
          />
          {dmsType === 12 && (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => setOpenAddUserDrawer(true)}
            >
              Add User
            </Button>
          )}
        </Box>
        <Table size={"small"}>
          <TableHead style={{ background: "#F2F3F4" }}>
            <TableCell>Full Name</TableCell>
            <TableCell>Login</TableCell>
            <TableCell>Password</TableCell>
            {tag == "datawarehouse" && <TableCell>Admin</TableCell>}

            {/* {tag == 'datawarehouse' && (
                            <TableCell>Last Updated (UTC)</TableCell>
                        )} */}
            <TableCell>Last Updated</TableCell>
            <TableCell>IDMS Last Login</TableCell>
            {/* <TableCell>Last RefreshToken (UTC)</TableCell> */}

            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableHead>
          {GetUserData().map((row: any) => {
            let password = row.password ?? "";
            if (password.length >= 4)
              password = password.substring(0, 2) + "***********";
            if (password.length < 4) password = password.replace(/./g, "*");
            let xclass = "";
            if (!row.isActive) xclass = classes.inActiveDealer;
            let lastIDMSLogin = "";
            //if (row.LastLoginTime != null) lastIDMSLogin = new Date(row.LastLoginTime).toLocaleString();
            //if (row.LastLoginTime != null) lastIDMSLogin =  new Date(row.LastLoginTime.toString().replace("T", " ") + " UTC").toLocaleString();
            if (row.LastLoginTime != null)
              lastIDMSLogin = ConvetToLocalTime(row.LastLoginTime);

            return (
              <TableRow
                hover
                onClick={(event) => onUserRowClick(row)}
                selected={selectedRow.userID == row.userID}
              >
                <TableCell className={xclass}>{row.fullName}</TableCell>
                <TableCell>{row.userName}</TableCell>
                <TableCell>{password}</TableCell>
                {/* {tag == 'datawarehouse' && (
                                    <TableCell style={{ textAlign: "center" }}>{row.IsAdmin == true ? "Yes" : "No"}</TableCell>

                                )}

                                {tag == 'datawarehouse' && (
                                    <TableCell>{row.LastUpdated}</TableCell>
                                    <TableCell>{row.LastLoginTime}</TableCell>
                                    <TableCell>{row.LastLoginTime}</TableCell>

                                )} */}
                <TableCell style={{ textAlign: "center" }}>
                  {row.IsAdmin == true ? "Yes" : "No"}
                </TableCell>
                <TableCell>{ConvetToLocalTime(row.LastUpdated)}</TableCell>
                {/* <TableCell>{row.LastLoginTime}</TableCell>
                                <TableCell>{row.LastLoginTime}</TableCell> */}
                <TableCell>
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={(event) => OnTokenClick(event, row.userName)}
                  >
                    {lastIDMSLogin}
                  </span>
                </TableCell>
                {/* <TableCell><span style={{ textDecoration: 'underline', cursor: "pointer" }} onClick={(event) => OnTokenClick(event, row.userName)}>{row.LastTokenGeneratedDateTime}</span></TableCell> */}

                <TableCell>
                  <Button
                    disabled={!hasTargetAccess}
                    variant="outlined"
                    size="small"
                    color="primary"
                    style={{ padding: "2px 10px 0px 10px" }}
                    onClick={(event: any) => {
                      OpenTarget(row);
                    }}
                  >
                    Open Target
                  </Button>{" "}
                </TableCell>

                <TableCell>
                  <Button
                    disabled={!hasTargetAccess}
                    variant="outlined"
                    size="small"
                    color="primary"
                    style={{ padding: "2px 10px 0px 10px" }}
                    onClick={(event: any) => {
                      GenerateToken(event, row);
                    }}
                  >
                    Generate Token
                  </Button>{" "}
                </TableCell>
              </TableRow>
            );
          })}
        </Table>

        <Popover
          open={showToken}
          anchorEl={anchorEl}
          // onClose={handleCloseOrderDetail}
          onClose={(event) => setShowToken(false)}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box>
            <div
              style={{
                backgroundColor: "#EAEDED",
                padding: "5px 10px 5px 6px",
              }}
            >
              Token for {GetDomainUser()}
            </div>
            <div
              style={{
                margin: "5px 10px 0px 5px",
                padding: "5px",
                fontSize: "small",
                border: "1px solid silver",
              }}
            >
              Dealer Number: {tempToken?.dealerNumber}
              <br></br>
              User Name: {tempToken?.userName}
              <br></br>
              Password: {tempToken?.password}
            </div>
            <div style={{ padding: "10px", fontSize: "small" }}>
              Password will expire in 5 min
            </div>
          </Box>
        </Popover>

        <Popover
          open={showRefreshTokenLog}
          anchorEl={anchorElTokenLog}
          // onClose={handleCloseOrderDetail}
          onClose={(event) => setShowRefreshTokenLog(false)}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box>
            <Box style={{ backgroundColor: "#E5E7E9", padding: "7px 5px" }}>
              Token Generated Logs ({selectedRow.userName})
            </Box>
            <Paper style={{ margin: "5px, 10px" }}>
              <Table size={"small"}>
                <TableHead style={{ backgroundColor: "#F2F3F4" }}>
                  <TableRow>
                    <TableCell>Token Date</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Product</TableCell>
                    <TableCell>Request Agent</TableCell>
                    <TableCell>Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {typeof refreshTokenData !== "undefined" &&
                    refreshTokenData != null &&
                    refreshTokenData.map((row: any, index: any) => {
                      return (
                        <TableRow hover>
                          <TableCell>
                            {ConvetToLocalTime(row.LastTokenGeneratedDateTime)}
                          </TableCell>
                          <TableCell>{row.UserName}</TableCell>
                          <TableCell>{row.Description}</TableCell>
                          <TableCell>{row.TokenRequestedUserAgent}</TableCell>
                          <TableCell>{row.TokenOperationNature}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </Paper>
          </Box>
        </Popover>
      </Box>

      {/* Add User Drawer */}
      <Drawer
        PaperProps={{ style: { width: "350px", padding: "20px" } }}
        anchor="right"
        open={openAddUserDrawer}
        onClose={() => setOpenAddUserDrawer(false)}
        variant={"temporary"}
      >
        <Box>
          <h3 style={{ marginTop: 0 }}>Add User</h3>
          <Box style={{ marginBottom: "15px" }}>
            <label>Name *</label>
            <input
              type="text"
              value={addUserForm.name}
              onChange={(e) => handleAddUserChange("name", e.target.value)}
              style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
            />
            {addUserErrors.name && <span style={{ color: "red", fontSize: "12px" }}>{addUserErrors.name}</span>}
          </Box>
          <Box style={{ marginBottom: "15px" }}>
            <label>Username *</label>
            <input
              type="text"
              value={addUserForm.userName}
              onChange={(e) => handleAddUserChange("userName", e.target.value)}
              style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
            />
            {addUserErrors.userName && <span style={{ color: "red", fontSize: "12px" }}>{addUserErrors.userName}</span>}
          </Box>
          <Box style={{ marginBottom: "15px" }}>
            <label>Password *</label>
            <input
              type="password"
              value={addUserForm.password}
              onChange={(e) => handleAddUserChange("password", e.target.value)}
              style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
            />
            {addUserErrors.password && <span style={{ color: "red", fontSize: "12px" }}>{addUserErrors.password}</span>}
          </Box>
          <Box style={{ marginBottom: "15px" }}>
            <label>Email *</label>
            <input
              type="email"
              value={addUserForm.email}
              onChange={(e) => handleAddUserChange("email", e.target.value)}
              style={{ width: "100%", padding: "6px", boxSizing: "border-box" }}
            />
            {addUserErrors.email && <span style={{ color: "red", fontSize: "12px" }}>{addUserErrors.email}</span>}
          </Box>
          <Box style={{ marginBottom: "15px", display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              id="isAdmin"
              checked={addUserForm.isAdmin}
              onChange={(e) => setAddUserForm((prev) => ({ ...prev, isAdmin: e.target.checked }))}
            />
            <label htmlFor="isAdmin" style={{ cursor: "pointer", userSelect: "none" }}>Admin</label>
          </Box>
          <Button
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            onClick={handleAddUserSubmit}
            style={{ width: "100%" }}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Box>
      </Drawer>
    </Drawer>
  );
}
export default CrmUsers;
